export default {
  title: 'Serviço de Reservas da Empresa Desativado',
  description: 'O serviço de reservas está atualmente inativo para esta empresa. Pode ativá-lo em Serviços.',
  button: {
    settings: 'Ir para Definições',
  },
};
